// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "index." + {"12":"e8ee76110c297e4b7c7c","777":"d8898ed1139bef48daf5"}[chunkId] + ".js";
};